import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02dee410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "btn-group" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-plus me-2" }, null, -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "input-group-text budget-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }, null, -1))
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-times" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary dropdown-toggle",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false",
          disabled: _ctx.budgetTypes.length === 0
        }, [
          _hoisted_4,
          _createTextVNode("เพิ่มงบประมาณ ")
        ], 8, _hoisted_3),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.budgetTypes, (budgetType) => {
            return (_openBlock(), _createElementBlock("li", {
              key: budgetType.id
            }, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: ($event: any) => (_ctx.addBudget(budgetType.id, budgetType.shortName))
              }, [
                _hoisted_7,
                _createTextVNode(_toDisplayString(budgetType.name), 1)
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["list-group", {'list-group-flush': _ctx.budgetForm.length !== 0}])
    }, [
      (_ctx.budgetForm.length === 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _hoisted_9,
            _createTextVNode("ไม่มีข้อมูล ")
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.budgetForm, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-group-item px-0 py-2",
              key: item.budgetTypeId
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(item.budgetTypeName), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                  placeholder: "กรุณาป้อนจำนวนงบประมาณ"
                }, null, 8, _hoisted_13), [
                  [
                    _vModelText,
                    item.amount,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-outline-danger",
                  onClick: ($event: any) => (_ctx.removeBudget(item.budgetTypeId))
                }, _hoisted_16, 8, _hoisted_14)
              ])
            ]))
          }), 128))
    ], 2)
  ], 64))
}